import { render } from "./Entitlements.vue?vue&type=template&id=8cabd4f4"
import script from "./Entitlements.vue?vue&type=script&lang=js"
export * from "./Entitlements.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sivasankarelango/Sivasankar/test-cx/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__